import {Post} from "./config";

// Recon end point
export const fetchRecons = (id, params) => Post( 'recon/' + id, params);
export const fetchSyncRecons = (id, params) => Post( 'recon/sync/' + id, params);
export const getDoubleTrx = (params) => Post( 'recon/get-duplicate?from_date=' + params.from_date + '&to_date=' + params.to_date, params);
export const fetchFoundRecons = (id, params) => Post( 'recon/found/' + id, params);
export const fetchUnFoundRecons = (id, params) => Post( 'recon/unfound/' + id, params);
